import { render, staticRenderFns } from "./student-tag-add.vue?vue&type=template&id=085d0e64&scoped=true"
import script from "./student-tag-add.vue?vue&type=script&lang=js"
export * from "./student-tag-add.vue?vue&type=script&lang=js"
import style0 from "./student-tag-add.vue?vue&type=style&index=0&id=085d0e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085d0e64",
  null
  
)

export default component.exports